import * as React from "react";
import styled from "@emotion/styled";
import QRCode from "react-qr-code";
import { H1, LoadingSpinner, Text } from "atoms";
import { Head } from "features/misc";
import { useAsync } from "utils/hooks";
import { getMagicLink, MagicLink } from "features/auth";

function MobileSignIn() {
  const { data, run } = useAsync<MagicLink>();

  React.useEffect(() => {
    if (!data) {
      run(getMagicLink());
    }
  }, [data, run]);

  const url = data?.url;

  return (
    <Columns>
      <Head title="Mobile Sign In" />

      <div>
        {url ? (
          <QRCode title="Mobile Sign In" value={url} />
        ) : (
          <LoadingSpinner />
        )}
      </div>
      <div>
        <H1>Mobile Sign In</H1>

        <Text>
          Scan the QR code using your mobile device to sign in to The&nbsp;HUG.
        </Text>
        <Text size="xs">
          <strong>Do not share this QR Code.</strong>
          <br />
          It will let others access your account.
        </Text>
      </div>
    </Columns>
  );
}

const Columns = styled.div(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: theme.spacing.xl,
  padding: theme.spacing.xl,
  minHeight: "60vh",
  textAlign: "center",
  svg: {
    margin: "0 auto",
    width: 256,
  },
  "@media (min-width: 760px)": {
    flexDirection: "row",
    textAlign: "left",
    div: {
      maxWidth: 380,
      marginTop: 0,
    },
  },
}));

export { MobileSignIn };
